import { render, staticRenderFns } from "./MessagesWidget.vue?vue&type=template&id=76456f6c&scoped=true"
import script from "./MessagesWidget.vue?vue&type=script&lang=ts"
export * from "./MessagesWidget.vue?vue&type=script&lang=ts"
import style0 from "./index.scss?vue&type=style&index=0&id=76456f6c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76456f6c",
  null
  
)

export default component.exports